import React, { Component } from 'react';

import TubeStand from './img/TubeStand-shorter.svg';

class Graphics extends Component {

  render () {
    return (
      <div>
        <img width="205px" src={TubeStand} aria-label={'Empty Tube Stand'} />
      </div>
    );
  }

}

export default Graphics;
